import { Component, Input, OnInit, inject } from "@angular/core";
import {IonicModule} from "@ionic/angular";
import {AsyncPipe} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {SharedAttachmentsService} from "@shared/components/attachments/services/shared-attachments.service";
import {AttachmentTypes} from "@server-models";
import {ILocalAttachmentDto} from "@shared/components/attachments/interfaces/orga-attachment-dto-extend.interface";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";
import {EAppType} from "@shared/models/AppType.enum";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-shared-attachments-row-item',
  templateUrl: './shared-attachments-row-item.component.html',
  styleUrls: ['./shared-attachments-row-item.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
    AsyncPipe
],
  standalone: true
})
export class SharedAttachmentsRowItemComponent {
  private _store = inject(Store);
  attachmentsService = inject(SharedAttachmentsService);

  @Input() mappedAttachments: ILocalAttachmentDto[];
  @Input() hasHeader: boolean;
  @Input() isIconFolderEnabled: boolean;
  @Input() lines: string = 'full';

  attachmentType: typeof AttachmentTypes = AttachmentTypes;
  isLink$: Observable<boolean>;

  constructor() {
    this.hasHeader = true;
    this.isIconFolderEnabled = false;
    this.mappedAttachments = [];
    this.isLink$ = this._store.select(SharedLoginSelectors.selectAppType).pipe(
      map(appType => appType === EAppType.Link)
    );
  }

}
